import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#F9C846',
      contrastText: '#123053',
    },
    secondary: {
      main: '#2C5077',
      contrastText: '#FFF7E1',
    },
    background: {
      default: '#123053',
      paper: '#2C5077',
    },
    text: {
      primary: '#FFF7E1',
      secondary: '#FFE58B',
    },
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          background: '#123053',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 18,
        },
      },
    },
  },
  typography: {
    fontFamily: '"Roboto", "Montserrat", "Arial", sans-serif',
  },
});

export { theme };
